import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

interface SplitTextProps {
  text: string;
  duration?: number;
  className?: string;
  onAnimationComplete?: () => void;
}

const SplitText: React.FC<SplitTextProps> = ({
  text,
  duration = 1,
  className = '',
  onAnimationComplete
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const chars = containerRef.current.querySelectorAll('.char');
    
    gsap.fromTo(
      chars,
      {
        opacity: 0,
        y: 50,
        rotateX: -90,
      },
      {
        opacity: 1,
        y: 0,
        rotateX: 0,
        duration: duration,
        ease: 'power3.out',
        stagger: 0.03,
        onComplete: onAnimationComplete,
      }
    );
  }, [text, duration, onAnimationComplete]);

  return (
    <div ref={containerRef} className={className} style={{ perspective: '1000px' }}>
      {text.split('').map((char, index) => (
        <span
          key={index}
          className="char inline-block"
          style={{ 
            display: 'inline-block',
            transformStyle: 'preserve-3d',
          }}
        >
          {char === ' ' ? '\u00A0' : char}
        </span>
      ))}
    </div>
  );
};

export default SplitText;
